import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Assessment from "@/pages/Assessment";
import Results from "@/pages/Results";
import Jobs from "@/pages/Jobs";
import Learning from "@/pages/Learning";
import Mentors from "@/pages/Mentors";
import Contact from "@/pages/Contact";
import PersonaPreview from "@/pages/PersonaPreview";
import Terms from "@/pages/legal/Terms";
import Privacy from "@/pages/legal/Privacy";
import Refund from "@/pages/legal/Refund";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback (session_id in URL fragment) synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/assessment/results/:id" element={<Results />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/learning" element={<Learning />} />
      <Route path="/mentors" element={<Mentors />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/for/:slug" element={<PersonaPreview />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund" element={<Refund />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
